const SvgDatabases1 = (props) => (
  <>
    <defs />
    <path d="M40 232h16v16H40zM40 296h16v16H40z" fill="#042068" strokeWidth={0} />
    <path d="M40 168h16v16H40zM328 104h16v16h-16zM328 232h16v16h-16z" fill="#0f62fe" strokeWidth={0} />
    <path
      d="M136 232h16v16h-16zM232 232h16v16h-16zM232 72h16v16h-16zM328 168h16v16h-16z"
      fill="#042068"
      strokeWidth={0}
    />
    <path d="M136 296h16v16h-16zM232 168h16v16h-16z" fill="#0f62fe" strokeWidth={0} />
    <path d="M96 384V0M192 384V0M288 384V0" fill="none" stroke="#042068" strokeMiterlimit={10} strokeWidth="3px" />
  </>
);

export default SvgDatabases1;
